module.exports = __webpack_public_path__ + "static/media/dps2.png.71133e66.jpg";